<template>
  <aside class="sidebar">
    <div class="sidebar__brand">
      <img src="@/assets/images/logo.png" class="sidebar__logo" alt="智慧能源运营平台" />
      <span class="sidebar__title">智慧能源运营平台</span>
    </div>

    <el-menu
      ref="menu"
      :default-active="activeMenu"
      :default-openeds="defaultOpeneds"
      class="sidebar__menu"
      background-color="transparent"
      text-color="#d9ecff"
      active-text-color="#ffffff"
      unique-opened
    >
      <!-- 动态渲染菜单组，数据来自 menuGroups（由路由 meta 构建） -->
      <el-submenu
        v-for="group in menuGroups"
        :key="group.path"
        :index="group.path"
      >
        <!-- 一级菜单标题：图标 + 文字 -->
        <template slot="title">
          <span class="menu-icon" v-html="group.svgTag"></span>
          <span class="menu-label">{{ group.title }}</span>
        </template>

        <!-- 直属二级菜单项 -->
        <el-menu-item
          v-for="sub in group.children"
          :key="sub.path"
          :index="sub.path"
          class="sub-item"
          @click="navigate(sub.path)"
        >
          <span class="sub-icon" v-html="svgIcon(sub.icon)"></span>
          <span>{{ sub.title }}</span>
        </el-menu-item>

        <!-- 三级子组（如运营活动） -->
        <el-submenu
          v-for="sg in group.subGroups"
          :key="sg.path"
          :index="sg.path"
          class="sub-submenu"
        >
          <template slot="title">
            <span class="sub-icon" v-html="svgIcon(sg.icon)"></span>
            <span>{{ sg.title }}</span>
          </template>
          <el-menu-item
            v-for="sub in sg.children"
            :key="sub.path"
            :index="sub.path"
            class="sub-item sub-item--deep"
            @click="navigate(sub.path)"
          >
            <span class="sub-icon sub-icon--sm" v-html="svgIcon(sub.icon)"></span>
            <span>{{ sub.title }}</span>
          </el-menu-item>
        </el-submenu>
      </el-submenu>
    </el-menu>

  </aside>
</template>

<script>
import { filterAuthorizedRoutes } from '@/utils/permission'

// 一级菜单组配置（图标 SVG 内容 + 标题），与 router meta.menu 对应
const GROUP_CONFIG = [
  {
    path: '/lifecycle',
    title: '项目生命周期',
    svgTag: `<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="8.5" stroke="currentColor" stroke-width="1.6"/>
      <path d="M10 6v4.2l2.8 1.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="10" cy="10" r="1" fill="currentColor"/>
    </svg>`
  },
  {
    path: '/operation',
    title: '运营管理',
    svgTag: `<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.5" y="1.5" width="17" height="17" rx="3" stroke="currentColor" stroke-width="1.6"/>
      <path d="M4 14l4-4.5 3 3 4.5-5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="4" cy="14" r="1.2" fill="currentColor"/>
      <circle cx="8" cy="9.5" r="1.2" fill="currentColor"/>
      <circle cx="11" cy="12.5" r="1.2" fill="currentColor"/>
      <circle cx="15.5" cy="7" r="1.2" fill="currentColor"/>
    </svg>`,
    // 三级子组配置
    subGroups: [
      {
        path: '/operation/activity-group',
        title: '运营活动',
        icon: '<path d="M8 1.5l1.8 3.6 4 .6-2.9 2.8.7 4L8 10.4l-3.6 2 .7-4L2.2 5.7l4-.6z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>'
      }
    ]
  },
  {
    path: '/maintenance',
    title: '运维管理',
    svgTag: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g transform="rotate(-45 12 12)" fill="currentColor">
        <path d="M8.5 1.5h2.5v6.5h2V1.5h2.5v8h-7z"/>
        <rect x="10.5" y="9.5" width="3" height="13" rx="1.5"/>
      </g>
      <g transform="rotate(45 12 12)" fill="currentColor" opacity="0.75">
        <rect x="9" y="1" width="6" height="7" rx="3"/>
        <rect x="11" y="8" width="2" height="12"/>
        <rect x="9.5" y="20" width="5" height="2" rx="0.5"/>
      </g>
    </svg>`
  },
  {
    path: '/settlement',
    title: '结算管理',
    svgTag: `<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="3" width="16" height="14" rx="2.5" stroke="currentColor" stroke-width="1.6"/>
      <path d="M6 8.5h8M6 11.5h5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      <path d="M6 5.5V2.5M14 5.5V2.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      <circle cx="15" cy="14" r="3.5" fill="currentColor"/>
      <path d="M13.8 14h2.4M15 12.8v2.4" stroke="#ffffff" stroke-width="1.4" stroke-linecap="round"/>
    </svg>`
  },
  {
    path: '/system',
    title: '系统管理',
    svgTag: `<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="2.8" stroke="currentColor" stroke-width="1.6"/>
      <path d="M10 2.5v2M10 15.5v2M2.5 10h2M15.5 10h2M4.6 4.6l1.4 1.4M14 14l1.4 1.4M4.6 15.4l1.4-1.4M14 6l1.4-1.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    </svg>`
  }
]

export default {
  name: 'AppSidebar',
  data() {
    return {
      groupConfig: GROUP_CONFIG
    }
  },

  computed: {
    activeMenu() {
      return this.$route.meta.activeMenu || this.$route.path
    },
    visibleRoutes() {
      // 有两条 path:'/' 路由（一条 redirect、一条 Layout），取有 children 的那条
      const layoutRoute = this.$router.options.routes.find(r => r.path === '/' && r.children && r.children.length)
      const children = (layoutRoute && layoutRoute.children) || []
      return children
        .filter(r => r.meta && !r.meta.hidden && r.meta.title && r.meta.menu)
        .map(r => ({
          path:    '/' + r.path,
          title:   r.meta.title,
          menu:    r.meta.menu,
          subMenu: r.meta.subMenu || null,
          icon:    r.meta.icon   || ''
        }))
    },
    authorizedRoutes() {
      // 依赖 store 里的 routerList，角色菜单变更后 SET_USER 触发此处重新计算
      const routerList = this.$store.state.user.routerList
      return filterAuthorizedRoutes(this.visibleRoutes, routerList)
    },
    menuGroups() {
      return this.groupConfig.map(group => ({
        ...group,
        children: this.authorizedRoutes.filter(r => r.menu === group.path && !r.subMenu),
        subGroups: (group.subGroups || []).map(sg => ({
          ...sg,
          children: this.authorizedRoutes.filter(r => r.subMenu === sg.path)
        })).filter(sg => sg.children.length)
      })).filter(group => group.children.length || group.subGroups.length)
    },
    defaultOpeneds() {
      const activePath = this.$route.meta.activeMenu || this.$route.path
      const exactMatch = g =>
        g.children.some(c => c.path === activePath) ||
        (g.subGroups || []).some(sg => sg.children.some(c => c.path === activePath))
      const group = this.menuGroups.find(exactMatch) ||
        this.menuGroups.find(g => activePath.startsWith(g.path))
      if (!group) return []
      const opens = [group.path]
      ;(group.subGroups || []).forEach(sg => {
        if (sg.children.some(c => c.path === activePath)) opens.push(sg.path)
      })
      return opens
    }
  },

  watch: {
    $route(to) {
      this.$nextTick(() => {
        const activePath = to.meta.activeMenu || to.path
        const menu = this.$refs.menu
        if (!menu) return
        const exactMatch = g =>
          g.children.some(c => c.path === activePath) ||
          (g.subGroups || []).some(sg => sg.children.some(c => c.path === activePath))
        const group = this.menuGroups.find(exactMatch) ||
          this.menuGroups.find(g => activePath.startsWith(g.path))
        if (!group) return
        menu.open(group.path)
        const sg = (group.subGroups || []).find(sg =>
          sg.children.some(c => c.path === activePath)
        )
        if (sg) menu.open(sg.path)
      })
    }
  },

  methods: {
    navigate(path) {
      if (this.$route.path !== path) {
        this.$router.push(path).catch(() => {})
      }
    },
    svgIcon(inner) {
      return `<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">${inner}</svg>`
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  position: relative;
  width: 15.6875rem;
  height: 100%;
  flex-shrink: 0;
  background: #00203f url('~@/assets/images/side-bg.png') center bottom / cover no-repeat;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar { width: 0; }
}

.sidebar__brand {
  position: relative;
  z-index: 2;
  height: 72px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(119, 191, 255, 0.16);
}

.sidebar__logo {
  width: 36px;
  height: 36px;
  object-fit: contain;
  flex-shrink: 0;
}

.sidebar__title {
  margin-left: 10px;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  white-space: nowrap;
}

.sidebar__menu {
  position: relative;
  z-index: 1;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 0 15rem;
  border-right: none !important;

  &::-webkit-scrollbar { width: 0; }

  // 一级菜单项（无子菜单）
  ::v-deep .el-menu-item.top-item {
    height: 50px;
    line-height: 50px;
    margin: 2px 10px;
    padding: 0 16px !important;
    border-radius: 7px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: $fw-medium;
    color: #d9ecff !important;
    background: transparent !important;
    transition: all 0.2s;

    &:hover {
      color: #fff !important;
      background: rgba(73, 153, 230, 0.2) !important;
    }

    &.is-active {
      color: #ffffff !important;
      background: #1769e8 !important;
      border-left: none;
      padding-left: 16px !important;
    }
  }

  // 一级折叠菜单（有子菜单）
  ::v-deep .el-submenu {
    margin: 2px 0;

    & > .el-submenu__title {
      height: 50px;
      line-height: 50px;
      margin: 0 10px;
      padding: 0 16px !important;
      border-radius: 7px;
      font-size: 16px;
      font-weight: $fw-medium;
      color: #d9ecff !important;
      background: transparent !important;
      transition: all 0.2s;
      display: flex;
      align-items: center;

      &:hover {
        color: #fff !important;
        background: rgba(73, 153, 230, 0.2) !important;
      }
    }

    &.is-opened > .el-submenu__title {
      color: #fff !important;
    }

    .el-submenu__icon-arrow {
      color: #aac9e8;
      font-size: 12px;
    }

    // 子菜单容器
    .el-menu {
      background: rgba(7, 46, 82, 0.72) !important;
      border-radius: 0 0 7px 7px;
      padding: 4px 0 6px;
      margin-top: -4px;
    }

    // 嵌套的三级 submenu（运营活动）
    .sub-submenu {
      & > .el-submenu__title {
        height: 40px;
        line-height: 40px;
        padding: 0 16px 0 36px !important;
        font-size: 16px;
        font-weight: $fw-normal;
        border-radius: 5px;
        margin: 1px 10px;
        display: flex;
        align-items: center;
        color: #d9ecff !important;
        background: transparent !important;
        transition: all 0.2s;

        &:hover {
          color: #fff !important;
          background: rgba(73, 153, 230, 0.2) !important;
        }
      }

      // 三级菜单容器
      .el-menu {
        background: transparent !important;
        border-radius: 0;
        padding: 2px 0 4px;
        margin-top: 0;
        margin-left: 20px;
      }
    }

    // 三级菜单项
    .el-menu-item.sub-item--deep {
      height: 36px;
      line-height: 36px;
      padding: 0 12px 0 16px !important;
      font-size: 14px;
      color: #bcd5ec !important;
      border-radius: 4px;
      margin: 1px 10px 1px 0;

      &:hover {
        color: #fff !important;
        background: rgba(73, 153, 230, 0.2) !important;
      }

      &.is-active {
        color: #ffffff !important;
        background: #1769e8 !important;
        padding-left: 16px !important;

        .sub-icon svg {
          stroke: rgba(255, 255, 255, 0.9);
        }
      }
    }

    // 二级菜单项
    .el-menu-item.sub-item {
      height: 40px;
      line-height: 40px;
      padding: 0 16px 0 36px !important;
      font-size: 16px;
      font-weight: $fw-normal;
      border-radius: 5px;
      margin: 1px 10px;
      display: flex;
      align-items: center;
      color: #d9ecff !important;
      background: transparent !important;
      transition: all 0.2s;

      &:hover {
        color: #fff !important;
        background: rgba(73, 153, 230, 0.2) !important;
      }

      &.is-active {
        color: #ffffff !important;
        background: #1769e8 !important;
        border-left: none;
        padding-left: 36px !important;

        .sub-icon svg {
          stroke: rgba(255, 255, 255, 0.9);
        }
      }
    }
  }
}

.menu-icon {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 10px;
  color: #8db9e5;
}

.sidebar__menu ::v-deep .el-submenu__title:hover .menu-icon,
.sidebar__menu ::v-deep .el-submenu.is-opened > .el-submenu__title .menu-icon {
  color: #fff;
}

.menu-label {
  font-size: 16px;
}

// 二级 / 三级菜单图标容器
.sub-icon {
  width: 14px;
  height: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 8px;
  opacity: 0.65;
  transition: opacity 0.2s;

  svg {
    stroke: currentColor;
    display: block;
  }

  // 三级菜单图标略小
  &.sub-icon--sm {
    width: 12px;
    height: 12px;

    svg {
      width: 12px;
      height: 12px;
    }
  }
}

// 激活 / 悬浮时图标不透明
.el-menu-item:hover .sub-icon,
.el-menu-item.is-active .sub-icon,
.el-submenu__title:hover .sub-icon {
  opacity: 1;
}

// 三级分组标题里的图标（运营活动）
.sub-submenu > .el-submenu__title .sub-icon {
  opacity: 0.65;
}

</style>
